import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

/**
 * Replaces all /media/ relative paths in CMS HTML with the full Umbraco media URL.
 * Handles all file types (pdf, images, documents, etc.) — not just specific extensions.
 */
export function replaceMediaUrls(html: string): string {
  if (!html) return html
  return html.replace(/(\/media\/[^"'\s)]+)/g, (match) => {
    return getUmbracoMediaUrl(match)
  })
}
